export default __webpack_public_path__ + "static/media/0118.d33224cc.jpg";